import {formatCurrency, formatNumber} from '@angular/common';

import { DetailScreen } from '../mapping-classes/detail-screen';
import { DetailPanel } from '../mapping-classes/detail-panel';
import { DetailLabel } from '../mapping-classes/detail-label';
import { LazyLoadingData } from '../mapping-classes/lazy-loading-data';
import { ButtonData } from '../mapping-classes/button-data';
import { padEnd } from 'lodash';

export class Exportincasso implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'Export Incasso';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.commercialProductTypeName || 'Export Incasso';
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
      this.addButtons(response);
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues();
      this.addValues(response);
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Productgebruik'));
  }

  setNameAndValues() {
    let product: DetailPanel = this.panels[0];
    this.fillProductFeatures(product);

    product = this.panels[1];
    this.fillProductAgreements(product);

    product = this.panels[2];
    this.fillProductUsage(product);
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    let productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductFeatures(productDetailsPanel, obj);

    productDetailsPanel = this.panels[1];
    this.addValuesToProductAgreements(productDetailsPanel, obj);

    productDetailsPanel = this.panels[2];
    this.addValuesToProductUsage(productDetailsPanel, obj);

  }

  addButtons(response) {
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductFeatures(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('referenceNumber', new DetailLabel('Referentienummer'));
    productDetailsPanel.nameAndValues.set('collectionConditionDesc', new DetailLabel('Soort Incasso'));
    productDetailsPanel.nameAndValues.set('drawer', new DetailLabel('Drawer'));
    productDetailsPanel.nameAndValues.set('drawee', new DetailLabel('Drawee'));
    productDetailsPanel.nameAndValues.set('collectionAddConditionDesc', new DetailLabel(''));
    //productDetailsPanel.nameAndValues.set('advancePresentInd', new DetailLabel('Discontering'));
  }

  private addValuesToProductFeatures(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('referenceNumber').setValue(obj.referenceNumber || '-');
    productDetailsPanel.nameAndValues.get('collectionConditionDesc').setValue(obj.collectionConditionDesc || '-');
    productDetailsPanel.nameAndValues.get('collectionAddConditionDesc').setValue(obj.collectionAddConditionDesc || '-');
   // productDetailsPanel.nameAndValues.get('advancePresentInd').setValue(obj.advancePresentInd || '-');
    productDetailsPanel.nameAndValues.get('drawer').setValue(obj.drawer || '-');
    productDetailsPanel.nameAndValues.get('drawee').setValue(obj.drawee || '-');
  }

  private fillProductAgreements(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('startDate', new DetailLabel('Openingsdatum'));
    productDetailsPanel.nameAndValues.set('maturityDate', new DetailLabel('Vervaldatum'));
    productDetailsPanel.nameAndValues.set('endDate', new DetailLabel('Einddatum'));
    productDetailsPanel.nameAndValues.set('openingAmountInEur', new DetailLabel( 'Opening bedrag EUR'));
    productDetailsPanel.nameAndValues.set('openingAmount', new DetailLabel('Opening bedrag VV'));
    productDetailsPanel.nameAndValues.set('collectingBankPartyName', new DetailLabel('Incasserende bank'));
    productDetailsPanel.nameAndValues.set('collectingBankCountryName', new DetailLabel('Land van de bank'));
  }

  private addValuesToProductAgreements(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('startDate').setValue(obj.startDate || '-');
    productDetailsPanel.nameAndValues.get('maturityDate').setValue(obj.maturityDate || '-');
    productDetailsPanel.nameAndValues.get('endDate').setValue(obj.endDate || '-');
    productDetailsPanel.nameAndValues.get('openingAmountInEur')
      .setValue((obj.openingAmountInEur && formatCurrency(obj.openingAmountInEur, 'nl', '€')) || '-');
    productDetailsPanel.nameAndValues.get('openingAmount').setValue(
      this.numberFormat(obj.openingAmount, obj.openingAmountCurrencyCode) || '-');
    productDetailsPanel.nameAndValues.get('collectingBankPartyName').setValue(obj.collectingBankPartyName || '-');
    productDetailsPanel.nameAndValues.get('collectingBankCountryName').setValue(obj.collectingBankCountryName || '-');
  }

  private fillProductUsage(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('openAmountInEur', new DetailLabel('Openstaand bedrag EUR'));
    productDetailsPanel.nameAndValues.set('openAmount', new DetailLabel('Openstaand bedrag VV'));
    productDetailsPanel.nameAndValues.set('docsAcceptedOnDate', new DetailLabel('Doc. Geaccepteerd'));
  }

  private addValuesToProductUsage(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('openAmountInEur').setValue((obj.openAmountInEur &&
      formatCurrency( obj.openAmountInEur, 'nl', '€')) || '-');
    productDetailsPanel.nameAndValues.get('openAmount').setValue(
      this.numberFormat(obj.openAmount, obj.openAmountCurrencyCode) || '-');
    productDetailsPanel.nameAndValues.get('docsAcceptedOnDate').setValue(obj.docsAcceptedOnDate || '-');
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }

  public numberFormat(num: number, currency: string) {
    if (!(num && currency)) {
      return null;
    }
    return `${formatNumber(num, 'nl-NL', '2.2-5')} ${currency}`
  }

}
